import React from 'react';
import { useSearchParams } from 'react-router-dom';

import styles from './stats.module.scss';
import { useGetStatsSalon } from '~/hooks/stats';
import ThreeSegmentYearTile from '~/components/ThreeSegmentYearTile';
import GlobalDistributionTile from '~/components/GlobalDistributionTile';
import Loader from '~/components/Loader';
import HorizontalBarsTile from '~/components/HorizontalBarsTile';
import CustomAreaChart from '~/components/AreaChart';
import StackedHorizontalBarsTile from '~/components/StackedHorizontalBarsTile';

const StatistiquesSalon = () => {
  const [searchParams] = useSearchParams();
  const region = searchParams.get('region') || undefined;

  const {
    data,
    isLoading,
    isFetching,
    error,
  } = useGetStatsSalon({ region });

  const currentYear = data?.nombreMagasinsPresents?.currentYear;
  const previousYear = data?.nombreMagasinsPresents?.previousYear;
  const repartitionGlobale = data?.repartitionGlobale;
  const repartitionParEnseigne = data?.repartitionParEnseigne || [];
  const repartitionParRegions = data?.repartitionParRegions || [];
  const evolutionEntreesSalon = data?.evolutionEntreesSalon?.points || [];

  if (isLoading || isFetching) {
    return (
      <div className={styles.pageLoader}>
        <Loader color="#007D92" />
      </div>
    );
  }

  if (error) {
    return <p>Erreur de chargement.</p>;
  }

  return (
    <div className={styles.salonTilesGrid}>
      <ThreeSegmentYearTile
        title="Nombre de magasins présents"
        rows={{
          primary: currentYear || {
            year: 2026,
            j1Only: 0,
            j2Only: 0,
            j1j2: 0,
          },
          secondary: previousYear || {
            year: 2025,
            j1Only: 0,
            j2Only: 0,
            j1j2: 0,
          },
        }}
      />

      <div className={styles.tile}>
        <GlobalDistributionTile
          title="Répartition globale"
          showDayTotals
          rows={repartitionGlobale || {
            j1Only: { fournisseurs: 0, magasins: 0, collaborateurs: 0 },
            j2Only: { fournisseurs: 0, magasins: 0, collaborateurs: 0 },
            j1j2: { fournisseurs: 0, magasins: 0, collaborateurs: 0 },
            total: { fournisseurs: 0, magasins: 0, collaborateurs: 0 },
            visiteursUniquesTotal: 0,
          }}
        />
      </div>

      <section className={styles.tileWide}>
        <h2>Evolution des entrées au salon</h2>
        <div className={styles.tileBody}>
          <div className={styles.chartDaysLegend}>
            <span className={`${styles.chartDayPill} ${styles.jour1}`}>
              Jour 1
            </span>
            <span className={`${styles.chartDayPill} ${styles.jour2}`}>
              Jour 2
            </span>
          </div>
          <div className={styles.chartContainer}>
            <CustomAreaChart
              data={evolutionEntreesSalon}
              xDataKey="xLabel"
              xTickStepHours={4}
              keys={[
                {
                  name: 'J1',
                  color: '#BCEBFB',
                  id: 'salon-evolution-j1',
                },
                {
                  name: 'J2',
                  color: '#D5D3FF',
                  id: 'salon-evolution-j2',
                },
                {
                  name: 'J1 n-1',
                  color: '#BCEBFB',
                  id: 'salon-evolution-j1-n1',
                  withFill: false,
                  strokeDasharray: '4 4',
                },
                {
                  name: 'J2 n-1',
                  color: '#D5D3FF',
                  id: 'salon-evolution-j2-n1',
                  withFill: false,
                  strokeDasharray: '4 4',
                },
              ]}
            />
          </div>
        </div>
      </section>

      <HorizontalBarsTile
        title="Répartition par enseigne"
        items={repartitionParEnseigne}
      />

      <StackedHorizontalBarsTile
        title="Répartition par régions et enseignes"
        items={repartitionParRegions}
      />
    </div>
  );
};

export default StatistiquesSalon;
